import { defineRoute } from '../defineRoute';

export type HomeRouteParams = {
  // ...
};

export type HomeRouteParamsString = {
  // ...
};

export const Home = defineRoute<HomeRouteParams, HomeRouteParamsString>({
  pathname: '/',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
